/** @format */

import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import GridContainer from '../../components/Grid/GridContainer.jsx';
import GridItem from '../../components/Grid/GridItem.jsx';
import Button from '../../components/CustomButtons/ButtonExt';

import I18n from '../../components/Translate/I18n';

import { authActions } from '../../modules/auth/actions';
import { AuthReducersType } from '../../modules/auth/reducer';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { Auth } from '../../modules/auth/Auth';
import { platformUserConstants } from '../../modules/platformuser/actions';
import { history } from '../../core/history';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { useSnackbar } from 'notistack';
import i18n from 'i18next';

declare global {
    interface Window {
        temporaryPasswordCustomSnackBarFix_DisableDefaultSnackbar: boolean;
    }
}

const DiscardCertificationModal = (): React.ReactElement => {
    const dispatch = useDispatch();
    const { certificationModalOpen } = useSelector((state: { auth: AuthReducersType }) => state.auth, shallowEqual);
    const [discarding, setDiscarding] = useState<boolean>(false);
    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = (): void => {
        // window.temporaryPasswordCustomSnackBarFix_DisableDefaultSnackbar = true;
        const itemLoaders = new ItemLoaders(dispatch);
        setDiscarding(true);
        itemLoaders.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/certification_requests/reject/' + Auth.getUserId())),
            platformUserConstants.DELETE,
            {},
            {
                onSuccess: () => {
                    // window.temporaryPasswordCustomSnackBarFix_DisableDefaultSnackbar = false;
                    enqueueSnackbar(i18n.t('auth:certificate.discarded'), { variant: 'success', autoHideDuration: 5000 });
                    hideModal();
                    Auth.clearToken();
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    history.push(process.env.REACT_APP_LOGIN_PAGE);
                    setDiscarding(false);
                },
                onError: (e: any) => {
                    enqueueSnackbar(i18n.t('auth:certificate.error'), { variant: 'error', autoHideDuration: 5000 });
                    // setTimeout(() => {
                    // window.temporaryPasswordCustomSnackBarFix_DisableDefaultSnackbar = false;
                    // }, 1000);
                    setDiscarding(false);
                },
            },
            { dispatchAfterCallback: false, dispatchErrorAfterCallback: true }
        );
    };

    const hideModal = (): void => {
        dispatch({ type: authActions.TOGGLE_MODAL, certificationModalOpen: false });
    };

    return (
        <Dialog fullWidth={true} maxWidth="sm" open={certificationModalOpen ?? false} keepMounted onClose={hideModal}>
            <DialogTitle id="alert-dialog-slide-title">
                <I18n trans={'auth:certificate.discard_your_certificates'} />
            </DialogTitle>
            <DialogContent>
                <GridContainer justify="center">
                    <GridItem xs={12} style={{ textAlign: 'center' }}>
                        <h4>
                            <I18n trans={'auth:certificate.confirm_self_discard'} />
                        </h4>
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <Button disabled={discarding} onClick={handleSubmit}>
                    {discarding && <I18n trans={'auth:certificate.awaiting_response'} />}
                    {!discarding && <I18n trans={'auth:certificate.discard'} />}
                </Button>
                <Button onClick={hideModal} color="secondary">
                    <I18n trans={'general:common.close'} />
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DiscardCertificationModal;
